/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { Abi } from "./Abi";
import * as t from "io-ts";

// required attributes
const AbiListResponseR = t.interface({});

// optional attributes
const AbiListResponseO = t.partial({
  data: t.readonlyArray(Abi, "array of Abi"),

  size: t.Integer,

  start: t.Integer,

  total: t.Integer
});

export const AbiListResponse = t.intersection(
  [AbiListResponseR, AbiListResponseO],
  "AbiListResponse"
);

export type AbiListResponse = t.TypeOf<typeof AbiListResponse>;
